export default __webpack_public_path__ + "static/media/grafema_clivitalbio_11.f66c8103.jpg";